<template>
  <draggable
    ref="drag"
    v-model="unallocatedNfes"
    v-bind="dragOptions"
    multi-drag
    selected-class="multi-drag"
    @update="onUpdate"
    @add="onAdd"
    @remove="onRemove"
    @start="onDragStart"
    @end="onDragEnd"
    style="min-height: 520px"
  >
    <nfe-card
      v-for="nfe in virtualNfesList"
      :key="nfe.id"
      :isCollapsed="isCollapsed"
      :unallocatedNfe="nfe"
      :selected="selectedNfes[nfe.id]"
      :isDragable="true"
      @update:selected="$emit('update:selected', nfe.id)"
    />
    <div v-if="unallocatedNfes.length" v-observe-visibility="handleNfesScroll"></div>
    <div class="d-flex justify-center align-center py-3" v-if="unallocatedNfes.length == 0">Nenhuma NFe encontrada</div>
  </draggable>
</template>

<script>
import NfeCard from '@/components/ManualBoardingImport/Stepper/NfeCard.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
    NfeCard
  },
  props: {
    nfes: {
      type: Array,
      default: () => []
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    selectedNfes: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dragOptions: {
        animation: 150,
        group: 'description',
        ghostClass: 'ghost',
        disabled: false,
        handle: '.handle-drag'
      },
      isDragging: false,
      nfesToShow: 10
    };
  },
  computed: {
    unallocatedNfes: {
      get() {
        return this.nfes;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    localSelectedNfe: {
      get() {
        return this.selectedNfes;
      },
      set(newVal) {
        this.$emit('update:selectedNfes', newVal);
      }
    },
    virtualNfesList() {
      return this.unallocatedNfes.slice(0, this.nfesToShow);
    }
  },

  methods: {
    onDragStart(e) {
      this.isDragging = true;
      e.item._selected_items = this.unallocatedNfes.filter((f) => this.localSelectedNfe[f.id]);
    },
    onDragEnd() {
      this.isDragging = false;
    },
    onUpdate(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocatedNfes = this.unallocatedNfes.filter((f) => !ids.includes(f.id));
        unallocatedNfes.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocatedNfes = unallocatedNfes;
      }
    },
    onRemove(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        this.unallocatedNfes = this.unallocatedNfes.filter((f) => !ids.includes(f.id));
      }
    },
    onAdd(e) {
      if (e.item._selected_items.length) {
        const ids = e.item._selected_items.map(({ id }) => id);
        const unallocatedNfes = this.unallocatedNfes.filter((f) => !ids.includes(f.id));
        unallocatedNfes.splice(e.newIndex, 0, ...e.item._selected_items);
        this.unallocatedNfes = unallocatedNfes;
      }
    },
    handleNfesScroll(isVisible) {
      if (!isVisible || this.nfesToShow >= this.unallocatedNfes.length) return;
      this.nfesToShow += 5;
    }
  }
};
</script>
<style scoped>
.ghost {
  display: none !important;
}
</style>
